/* eslint-disable @typescript-eslint/explicit-function-return-type */
// ChatContext.tsx
import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from 'react';
import { AiChat } from 'model/modules/chatAi/chatAi';

interface ChatContextType {
  activeChat: AiChat | null;
  setActiveChat: (chat: AiChat | null) => void;
  resetChat: () => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider = ({ children }: { children: ReactNode }) => {
  const [activeChat, setActiveChat] = useState<AiChat | null>(null);

  const resetChat = useCallback(() => {
    setActiveChat(null);
  }, []);

  return (
    <ChatContext.Provider value={{ activeChat, setActiveChat, resetChat }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }

  return context;
};
